import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=0cb532fe&scoped=true"
import script from "./schedule.vue?vue&type=script&lang=js"
export * from "./schedule.vue?vue&type=script&lang=js"
import style0 from "./schedule.vue?vue&type=style&index=0&id=0cb532fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb532fe",
  null
  
)

export default component.exports